import React from 'react'
import { MdClear } from "react-icons/md";
import { FaMagnifyingGlass } from 'react-icons/fa6'

const ContractorSearchSection = ({ textSearch, setTextSearch }) => {

  return (
    <div className="row contractor-page-filter-holder">
      <div className="col-auto">
        <FaMagnifyingGlass size={25} color='var(--primary)' />
      </div>
      <div className="col">
        <input className='contractor-searchBox-input' type='text'
          required={true}
          placeholder={'Szukaj'}
          value={textSearch}
          onChange={(e) => { setTextSearch(e.target.value) }}
          onFocus={() => { }} />
      </div>
      <div className="col-auto">
        <MdClear size={25} color='var(--primary)' cursor={'pointer'} onClick={() => setTextSearch("")} />
      </div>
    </div>
  )
}

export default ContractorSearchSection